import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { ClubSchedule, Schedule, ScheduleCalendar, ScheduleGameDay } from './types';

export const useScheduleQuery = (date: string, enabled: boolean): ApiResponseNHL<Schedule> =>
    useFetchLeagueData(`/schedule/${date}`, enabled);

export const useScheduleCalendarQuery = (date?: string): ApiResponseNHL<ScheduleCalendar> =>
    useFetchLeagueData(`/schedule-calendar/${date || 'now'}`);

export const useClubScheduleMonthQuery = (
    club: ShortCodeEnums.TeamTriCode,
    date?: string
): ApiResponseNHL<ClubSchedule> => useFetchLeagueData(`/club-schedule/${club}/month/${date ? date : 'now'}`);

export const useClubScheduleWeekQuery = (
    club: ShortCodeEnums.TeamTriCode,
    enabled: boolean,
    date?: string
): ApiResponseNHL<ClubSchedule> => useFetchLeagueData(`/club-schedule/${club}/week/${date ? date : 'now'}`, enabled);

export const useClubSeasonScheduleQuery = (
    club: ShortCodeEnums.TeamTriCode,
    enabled: boolean,
    seasonId?: string
): ApiResponseNHL<ClubSchedule> =>
    useFetchLeagueData(`/club-schedule-season/${club}/${seasonId ? seasonId : 'now'}`, enabled);

export const filterScheduleByTeam = (schedule: Schedule, teamAbbrev: string): Schedule => {
    let games = 0;
    const gameWeek: Array<ScheduleGameDay> = [];
    schedule.gameWeek?.forEach((gameDay) => {
        if (gameDay.games) {
            const filteredGames = gameDay.games.filter(
                (game) =>
                    game.homeTeam.abbrev.toLowerCase() === teamAbbrev ||
                    game.awayTeam.abbrev.toLowerCase() === teamAbbrev
            );
            games += filteredGames.length;
            gameWeek.push({
                ...gameDay,
                games: filteredGames,
                numberOfGames: filteredGames.length,
            });
        }
    });
    return {
        ...schedule,
        gameWeek: gameWeek,
        numberOfGames: games,
    };
};

export const getGamesByDay = (clubSchedule: ClubSchedule): Schedule => {
    let numberOfGames = 0;
    const gamesPerDay: { [key: string]: ScheduleGameDay } = {};

    clubSchedule.games?.forEach((game) => {
        if (!gamesPerDay[game.gameDate]) {
            gamesPerDay[game.gameDate] = {
                date: game.gameDate,
                games: [],
                numberOfGames: 0,
            };
        }

        numberOfGames += 1;
        gamesPerDay[game.gameDate].numberOfGames += 1;
        gamesPerDay[game.gameDate].games.push(game);
    });

    return {
        nextStartDate: clubSchedule.nextStartDate || '',
        previousStartDate: clubSchedule.previousStartDate || '',
        clubTimezone: clubSchedule.clubTimezone,
        numberOfGames,
        gameWeek: Object.values(gamesPerDay),
    };
};
